import React, { useState } from 'react';
import { JsonUploadForm } from '../dialogs/components/json-upload-form';
import { GlobalVariables } from '../../GlobalVariables';
import { formatDate } from './elements/Forms/DateTimeInput';
import Reload from './icons/Reload';
import { useSelector } from 'react-redux';
import { lastTransactionDateReloadingState } from '../../redux/slices/statusesSlice';
import { lastTransactionDateState } from '../../redux/slices/tsSlice';
import { ReduxUpdater } from '../../redux/ReduxUpdater';
import { ApiCalls } from '../../ApiCalls';
import { toast } from 'react-toastify';
import CreateReceipt from './elements/CreateReceipt';

const IntegrationsContent = () => {
    const isLastTransactionDateReloading = useSelector(lastTransactionDateReloadingState);
    const lastTransactionDateUpdatedTS = useSelector(lastTransactionDateState);

    const [selectedTab, setSelectedTab] = useState<'banking' | 'zoho' | 'receipt'>('banking');

    React.useEffect(() => {
        if (selectedTab === 'receipt') {
            GlobalVariables.manualReceipt = null;
        }
    }, [selectedTab])

    React.useEffect(() => {
        console.log('lastTransactionDateUpdatedTS', lastTransactionDateUpdatedTS);
        ReduxUpdater.lastTransactionDateReloading = true;
        ApiCalls.lastTransaction().then(d => {
            console.log('lastTransactionDateUpdatedTS ENDED!!!');
            ReduxUpdater.lastTransactionDateReloading = false;
            GlobalVariables.lastTransactionDate = d;
        }).catch(err => console.error(err));
    }, [lastTransactionDateUpdatedTS]);

    return (
        <div className="flex items-start justify-start min-h-[100%] p-8">
            <div className="w-full max-w-4xl min-h-[100px]">
                <div className="bg-white relative border border-1 rounded-[16px] size-full" data-name="Tabs Container">
                    <div className="size-full">
                        <div className="box-border content-stretch flex flex-col gap-[45px] items-start overflow-clip px-[39px] py-[32px] relative size-full">
                            <div className="content-stretch flex gap-[21px] items-start relative shrink-0 w-full">
                                <button
                                    className={`box-border content-stretch flex gap-[10px] items-center justify-center overflow-clip px-[14px] py-[15px] relative rounded-[8px] shrink-0 cursor-pointer transition-colors ${selectedTab === 'banking' ? 'bg-[#cbd5e0]' : 'hover:bg-[#e2e8f0]'}`}
                                    onClick={() => setSelectedTab('banking')}
                                >
                                    <p className="font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#4a5568] text-[16px] text-nowrap whitespace-pre">
                                        Banking | Sparkasse
                                    </p>
                                </button>
                                <button
                                    className={`box-border content-stretch flex gap-[10px] items-center justify-center overflow-clip px-[14px] py-[15px] relative rounded-[8px] shrink-0 cursor-pointer transition-colors ${selectedTab === 'zoho' ? 'bg-[#cbd5e0]' : 'hover:bg-[#e2e8f0]'}`}
                                    onClick={() => setSelectedTab('zoho')}
                                >
                                    <p className="font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#4a5568] text-[16px] text-nowrap whitespace-pre">
                                        Accounting | Zoho
                                    </p>
                                </button>
                                {/* <button
                                    className={`box-border content-stretch flex gap-[10px] items-center justify-center overflow-clip px-[14px] py-[15px] relative rounded-[8px] shrink-0 cursor-pointer transition-colors ${selectedTab === 'receipt' ? 'bg-[#cbd5e0]' : 'hover:bg-[#e2e8f0]'}`}
                                    onClick={() => setSelectedTab('receipt')}
                                >
                                    <p className="font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#4a5568] text-[16px] text-nowrap whitespace-pre">
                                        Create receipt
                                    </p>
                                </button> */}
                            </div>
                            {selectedTab === 'banking' && <div className="content-stretch flex flex-col gap-[10px] items-start justify-center relative shrink-0 w-full">
                                <div className="overflow-clip relative shrink-0 w-[708px]">
                                    <span className="mx-auto text-xl font-bold">Most recent (extracted) POS transaction date: {isLastTransactionDateReloading ? <div className="w-4 h-4 animate-spin inline-flex"><Reload height={16}/></div> : formatDate(GlobalVariables.lastTransactionDate)}</span>
                                    <JsonUploadForm />
                                </div>
                            </div>}
                            {selectedTab === 'zoho' && <div className="content-stretch flex flex-col gap-[10px] items-start justify-center relative shrink-0 w-full">
                                <div className="overflow-clip relative shrink-0 w-[708px]">
                                    <button
                                        className="bg-[#63b3ed] w-full box-border content-stretch flex gap-[10px] items-center justify-center overflow-clip px-[14px] py-[21px] relative rounded-[8px] shrink-0"
                                        onClick={() => {
                                            ApiCalls.syncChartOfAccounts().then(res => {
                                                if (res) {
                                                    toast.success('Sync finished');
                                                } else {
                                                    toast.error('Sync failed!');
                                                }
                                            }).catch(err => {
                                                console.error(err);
                                                toast.error('Failed');
                                            });
                                        }}
                                    >
                                        <p className="font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[16px] text-nowrap text-white whitespace-pre">Sync Chart Of Accounts: All Yachts</p>
                                    </button>
                                </div>
                            </div>}
                            {selectedTab === 'receipt' && <div className="content-stretch flex flex-col gap-[10px] items-start justify-center relative shrink-0 w-full">
                                <div className="overflow-clip relative shrink-0 w-[708px]">
                                    <CreateReceipt isBoatCash={true} />
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntegrationsContent;